<template>
  <div id="frm_message">
		<form @click="canUserMessage()" v-if="!msg_success && (!invitation || invitation.fk_status == InvitationStatus.expirado)" v-on:submit.prevent="sendMessage()">
            <div class="dv_msg_success m-t-30 m-b-20 text-left">
                <p>Vocês poderão negociar o aluguel pelo chat do WebQuarto, assim que {{ name }} te responder.</p>

                <p class="m-b-5"><b>Mensagens Salvas</b> <i class="far fa-question-circle"></i></p>
                <div class="saved-messages m-b-20">
                    <span v-for="msg, i in saved_messages" @click="setMessage(msg)" v-bind:key="i" class="label label-success m-r-10 m-b-5">{{ msg.message | truncate(45)}}</span>
                    <button class="btn btn-sm btn-link btn-white" type="button" @click="openSavedMessagesModal()">+ Adicionar Nova</button>
                </div>
                <div class="form-group" v-bind:class="{'has-error': errors.has('message')}">
                    <textarea name="message" v-validate="'required'" class="form-control" v-model="form.message" :placeholder="'Digite aqui sua mensagem para ' + name + '.'" rows="4"></textarea>
                    <span class="help-block text-left" v-show="errors.has('message')">
                        <strong>{{ errors.first('message') }}</strong>
                    </span>
                </div>
            </div>

			<button type="submit" class="btn btn-success btn-invitation btn-lg btn-block waves-effect waves-light ladda-button">
				<span class="ladda-label">Enviar Contato</span>
			</button>

            <p v-if="!premium_host" class="text-mutted m-t-10 m-b-20 text-left">
                <b>Custo</b>: <span class="coins-amount">{{ ic_amount }}<img src="/images/icone_moeda.svg" alt="" /></span> <a class="btn-link m-l-10" target="_blank" href="https://ajuda.webquarto.com.br/article/149-o-que-sao-as-moedas-webquarto-e-como-funcionam">O que é isso?</a>
            </p>
		</form>
        <div v-if="invitation && invitation.fk_status != InvitationStatus.expirado">
			<div v-if="invitation.fk_status == InvitationStatus.aguardando_roommate">
				<div class="dv_msg msg_success">
					<img class="icon" src="/images/sent.svg" alt="Sent Icon">
                    <h4 class="text-custom">Mensagem enviada com sucesso. E agora?</h4>
                    <p>Enviamos sua mensagem para {{ name }}. Fique atento(a) a sua caixa de mensagens e notificações para saber quando {{ name }} te responder.</p>
                    <div v-if="!premium_host">
                        <hr>
                        <h5>Torne-se um Anunciante Profissional</h5>
                        <p>Envie convites sem limites e sem a necessidade de recarregar moedas.</p>
                        <a href="/host/subscription-landing" class="btn btn-success">Saber Mais</a>
                    </div>
                    <div>
                        <hr>
                        <p>Aproveite e baixe nosso app, assim você é notificado quando {{ name }} responder este convite 😉!</p>
                        <div class="row link_app m-b-15">
                            <a href="https://play.google.com/store/apps/details?id=com.webquarto.b2c.app&referrer=utm_source%3Dwebquarto_website%26utm_medium%3Dwebsite_footer" target="_blank">
                                <img src="https://play.google.com/intl/en_us/badges/static/images/badges/pt-br_badge_web_generic.png" alt="Google Play Logo" width="144" srcset="">
                            </a>
                            <a href="https://apps.apple.com/br/app/webquarto/id1490298196" target="_blank">
                                <img src="https://www.webquarto.com.br/images/appstore.png" alt="App Store Logo" width="120">
                            </a>
                        </div>
                    </div>
				    <a :href="'/mensagens/' + fk_user" class="btn btn-success btn-block btn-message-sent">Ver Caixa de Mensagens</a>
				</div>
			</div>
			<div v-else-if="invitation.fk_status == InvitationStatus.aguardando_anunciante || invitation.fk_status == InvitationStatus.aceita_anunciante || invitation.fk_status == InvitationStatus.aceita_roommate || invitation.fk_status == InvitationStatus.negada_anunciante || invitation.fk_status == null">
				<div class="dv_msg msg_success">
					<img class="icon" src="/images/accepted.svg" alt="" width="55">
					<h4 class="text-custom">Você já possui uma conversa em andamento com {{ name }}.</h4>
					<p>Clique no botão abaixo para abrir sua conversa com {{ name }}.</p>
					<a :href="'/mensagens/' + fk_user" class="btn btn-success btn-block btn-message-sent">Ver Conversa</a>
				</div>
			</div>
			<div v-else-if="invitation.fk_status == InvitationStatus.negada_roommate">
				<div class="dv_msg msg_danger">
					<i class="far fa-2x fa-times-circle text-danger"></i>
					<h4 class="text-danger">{{ name }} recusou o seu convite.</h4>
                    <p>No momento, {{ name }} não tem interesse em seu anúncio.
                        Você poderá enviar um novo convite para {{ name }} após 45 dias.</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
var Ladda = require('../../../../../../legacy/node_modules/ladda');
import { InvitationStatus } from './../../../constants/invitation';
export default {
    props: [
        'name',
        'fk_user',
        'fk_roommate',
        'capability',
        'authenticated',
        'location_object',
        'pinvitation',
        'ic_amount',
        'premium_host'
    ],
    data: function(){
        return {
            msg_success: false,
            contact_capability: this.capability,
            invitation: this.pinvitation,
            InvitationStatus: InvitationStatus,
            saved_messages: [],
            form: {
                message: '',
                fk_user: this.fk_user,
                fk_roommate: this.fk_roommate,
                initial_message: 1,
                fk_property: null,
                target: 'r'
			}
        };
    },
    filters: {
        truncate: function(string, value) {
            if (string.length > value)
                return string.substring(0 , value) + '...';
            else
                return string;
        }
    },
    methods: {
        canUserMessage() {
            if (!this.authenticated) {
                EventBus.$emit('open-modal', 'register-modal');
                window.dataLayer.push({
                    'event': 'show_login_modal',
                    'event_category': 'roommate_ad_page',
                    'event_label': 'send_message'
                });
                return false;
            }

            return true;
        },
        openSavedMessagesModal() {
            EventBus.$emit('open-modal', 'saved-messages-modal');
        },
        loadSavedMessages() {
            axios.get('/message/saved-messages').then(res => {
                if (res.data)
                    this.saved_messages = res.data.messages;
            });
        },
        setMessage(obj) {
            this.form.message = obj.message;
        },
        sendMessage: function (e) {
            if (!this.canUserMessage())
                return;

            var form = this.form;
            this.$validator.validateAll().then((result) => {
                if (!result)
                    return;

                let l = Ladda.create( this.$el.querySelector('.btn-invitation') );
                l.start();
                axios.post('/message/send-message', form).then((response) => {
                    l.stop();
                    const data = response.data;
                    if (data.success) {
                        window.App.success('Mensagem enviada com sucesso! Fique atento a sua Caixa de Mensagens.');
                        window.dataLayer.push({
                            'event': 'init_contact_ad',
                            'event_category': 'roommate_ad_page',
                            'event_label': 'init_contact_ad'
                        });
                        this.msg_success = true;
                        this.invitation = data.invitation;
                    } else {
                        if (data.error == 'insuficient_credits') {
                            EventBus.$emit('open-modal', 'need-credits-modal');
                        }
                    }
                }).catch(function (error) {
                    l.stop();

                    if (error.response && error.response.status == 401) {
                        EventBus.$emit('open-modal', 'register-modal');
                        window.dataLayer.push({
                            'event': 'show_login_modal',
                            'event_category': 'roommate_ad_page',
                            'event_label': 'send_message'
                        });
                    } else if (error.response && error.response.status == 403) {
                        window.App.error('Você não pode enviar uma mensagem para esta pessoa!');
                    } else
                        window.App.error('Ocorreu um erro ao enviar sua mensagem. Atualize esta página e tente novamente!');
                });
            });
        }
    },
    created() {
        this.loadSavedMessages();
        this.$validator.localize('pt_BR', {
            messages: {
                required: 'Preencha uma mensagem no campo acima.',
            },
        });

        EventBus.$on('roommate_ad_created', () => {
            this.contact_capability = 'allowed';
        });

        EventBus.$on('message_sent', (res) => {
            this.msg_success = true;
            this.invitation = res.invitation;
        });
    }
}
</script>

<style lang="scss" scoped>
.saved-messages .label{
    font-size: 12px;
    font-weight: normal;
    cursor: pointer;
    display: inline-block;
    padding: 5px 10px 4px;
}

.coins-amount {
    font-weight: bolder;
    color: #5f6261;

    img {
        margin-left: 4px;
        width: 14px;
        height: 14px;
    }
}

.dv_msg_exist {
    background: #55748F;
    color: #FFF;
    padding: 15px;
    border-radius: 5px;
}

.dv_msg{
    background: #FFF;
    padding: 15px;
    border: solid 1px;
    border-radius: 5px 5px 0 0;
    border-color: #CCC;
}

.dv_msg img.icon {
    width: 45px;
    margin-bottom: 15px;
}

.dropdown-menu{
    .form-group{
        padding-left: 10px;
    }
}

.btn-outline-orange {
    border-color: #FFC14D !important;
}

.w-9 {
    width: 20px;
    margin-left: 5px;
}

.dropdown-myads {
    width: 100%;
    padding: 10px;
    max-height: 500px;
    overflow-y: scroll;
}

.propertyad_dropdown .btn{
    padding: 8px !important;
}

.row.link_app {
	display: flex;
    align-items: center;
    justify-content: center;
}

.property_ad_item {
    display: flex;
    flex-direction: row;
    overflow: hidden;
    img {
        height: 50px;
        max-width: 50px;
    }

    .property_ad_cnt {
        flex-direction: column;
        padding-left: 10px;
        text-overflow: ellipsis;
        width: calc(100% - 60px);
        text-align: left;

        p {
            margin: 0;
            width: 100%;
            white-space: nowrap;
        }
    }
}

.radio.adr {
    input[type=radio] {
        top: 17px;
    }

    hr {
        margin: 10px 0 20px 0 !important;
    }

    label {
        width: 100%;
    }

    label::before {
        top: 17px;
    }

    label::after {
        top: 20px;
    }
}
</style>
